import { ISetRedirectionPathAfterAuthAction } from "@common/redux/public/interface";

const prefix = "public/";

export const publicActions = {
  SET_REDIRECT_PATH_AFTER_AUTH: `${prefix}SET_REDIRECT_PATH_AFTER_AUTH`,
};
export const setRedirectionPathAfterAuthAction = (
  redirectionPath: string
): ISetRedirectionPathAfterAuthAction => {
  return {
    type: publicActions.SET_REDIRECT_PATH_AFTER_AUTH,
    payload: redirectionPath,
  };
};
